
import React, { Component, useEffect, useState } from "react";
import { Error } from "@progress/kendo-react-labels";
import { DatePicker, DatePickerChangeEvent, MultiViewCalendar } from "@progress/kendo-react-dateinputs";

export interface DatePickerProps {
  onChange?: (newValue: DatePickerChangeEvent) => void
  error?: any,
  name?: string,
  title?: string,
  value?: Date,
  required?: boolean,
  validityStyles?: any,
  label?: string,
  placeholder?: string,
  max?: Date,
  min?: Date,
  disabled?: boolean,
  ref?: any,
  format?: any
}

function DatePickerKendoRct(props: DatePickerProps) {

  const {
    onChange,
    error,
    name,
    title,
    value,
    required,
    validityStyles,
    label,
    placeholder,
    max,
    min,
    disabled,
    ref,
    format
  } = props;

  return (
    <div>
      <DatePicker calendar={CustomCalendar}
        onChange={onChange}
        format={"MM/dd/yyyy"}
        value={value ? value : null}
        name={name}
        size={"medium"}
        title={title}
        required={required}
        validityStyles={validityStyles}
        max={max}
        label={label}
        placeholder={placeholder}
        min={min}
        disabled={disabled}
        ref={ref}
      />
      {error && <Error>{error}</Error>}
    </div>
  );

}

export default DatePickerKendoRct;
export const CustomCalendar = (props: any) => {
  return <MultiViewCalendar {...props} views={1} />;
};


